var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger mt-3 mb-5"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.lang.polaris.training.delete_registration_warning)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }